import { createFileRoute, redirect } from "@tanstack/react-router"

// Billing moved to the top level (`/billing`); keep old links working.
export const Route = createFileRoute("/_shell/voxlane/billing/")({
  beforeLoad: () => {
    throw redirect({ to: "/billing", replace: true })
  },
})
